"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalyticCallback = void 0;
var react_1 = require("react");
var use_analytics_1 = require("./use-analytics");
function useAnalyticCallback(eventName, fn) {
    var analytics = use_analytics_1.useAnalytics();
    return react_1.useCallback(fn === undefined
        ? function () { return analytics.dispatcher.dispatch(eventName); }
        : function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var result = fn.apply(void 0, args);
            analytics.dispatcher.dispatch(eventName);
            return result;
        }, [fn, eventName, analytics]);
}
exports.useAnalyticCallback = useAnalyticCallback;
